import { Component } from "@angular/core";

@Component({
  selector: "app-registration-simple-help",
  templateUrl: "./registration-simple-help.component.html",
  styleUrls: ["./registration-simple-help.component.scss"]
})
export class RegistrationSimpleHelpComponent { }
